import { Tooltip as TTip } from 'react-tooltip';
import { offset, flip, shift } from '@floating-ui/dom';

/** Middlewares: keep offset/shift, disable flip so place="bottom" is respected and tooltip stays below anchor. */
const tooltipMiddlewares = [
	offset(10),
	flip({ mainAxis: false, crossAxis: false }),
	shift({ padding: 5 }),
];

const Tooltip = (props) => {
	return (
		<TTip
			id="instantTooltip"
			place="bottom"
			positionStrategy="fixed"
			middlewares={tooltipMiddlewares}
			delayShow={400}
			border="1px solid hsl(var(--card-bd))"
			className="bg-card border border-card-bd p-4 max-w-[300px] rounded-card shadow-[0_4px_12px_rgba(0,0,0,0.15)]"
			render={({ content, activeAnchor }) => {
				const header = activeAnchor?.dataset?.tooltipHeader;
				const html = activeAnchor?.dataset?.tooltipHtml;
				if (html) {
					return <div dangerouslySetInnerHTML={{ __html: html }} />;
				}
				if (!content && !header) return null;
				return (
					<div>
						{header && (
							<div className="font-bold mb-2 text-base text-text-2">{header}</div>
						)}
						{content && (
							<div className="text-sm text-text">
								{String(content)
									.split("\n")
									.map((line, i) => (
										<div key={i} className={i ? "mt-1" : undefined}>
											{line}
										</div>
									))}
							</div>
						)}
					</div>
				);
			}}
		/>
	);
};

export default Tooltip;
